"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passive_EnrageEffectHandler = exports.Passive_EnrageEffectArgs = void 0;
const __1 = require("../../..");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class Passive_EnrageEffectArgs {
    constructor(healthThreshold, damageIncreasePercent) {
        this.healthThreshold = healthThreshold;
        this.damageIncreasePercent = damageIncreasePercent;
        this.__type = EffectType_1.EffectType.Passive_Enrage;
        this.__typeName = "Passive_Enrage";
        this.name = "Enrage";
        this.harmful = false;
    }
}
exports.Passive_EnrageEffectArgs = Passive_EnrageEffectArgs;
let Passive_EnrageEffectHandler = class Passive_EnrageEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            healthThreshold: state.args.healthThreshold,
            damageIncreasePercent: state.args.damageIncreasePercent
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.AttributeChanged, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_Enrage_OnHealthChange", scriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
Passive_EnrageEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Passive_Enrage)
], Passive_EnrageEffectHandler);
exports.Passive_EnrageEffectHandler = Passive_EnrageEffectHandler;
